import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PerformanceColumn from "../utils/graphs/PerformanceColumn";
import PerformanceDonut from "../utils/graphs/PerformanceDonut";
import UserLayout from "../utils/user/UserLayout";
import { fetchDashboardAction } from "../../redux/actions/dashboard/dashboardAction";
import {
  fetchPerformanceAction,
  sendProfileConnectionAction,
  updatePerformanceAction,
  fetchSendMyProfileAction,
  // sendProfileConnectionAction
} from "../../redux/actions/performance/perfrmanceAction";
// import { sendMyProfilePdfConnection } from "../../reudux/actions/user/networkAction";
import { fetchAnalyticsAction } from "../../redux/actions/analytics/analyticsAction";
import { useForm } from "react-hook-form";
import Select from "react-select";
import axiosInstance from "../authentication/helper/axiosApi";
import { Pdf } from "../network/helper/CV/Pdf";
import axios from "axios";
import ReactToPrint from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { IMAGEAPI } from "../../BackendConnections";
import html2pdf from "html2pdf.js";
import { ToastContainer, toast } from "react-toastify";
import PerformanceBar from "../utils/graphs/PerformanceBar";
import PerformanceColumnSmall from "../utils/graphs/PerformanceColumnSmall";
import Spinner from "react-bootstrap/Spinner";
import { ClipLoader } from "react-spinners";
import "./performance.css";
import Footer from "../utils/core/Footer";

export const Performance = (props) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const componentRef = useRef();
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [sendMyProfileResp, setSendMyProfileResp] = useState(false);

  // React Hook Form setup
  const {
    register,
    // handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //Initial data states
  const [data, setData] = useState([0, 0, 0, 0]);
  const [peerData, setPeerData] = useState([0, 0, 0, 0]);
  const [pdfData, setPdfData] = useState([[0], [0], [0]]);
  const [isData, setIsData] = useState({
    is_dashboard: false,
    is_performance: false,
    is_analytics: false,
  });

  // Form submission handler
  const onSubmit = (data, event) => {
    event.preventDefault();

    if (Object.keys(errors).length === 0) {
      props.sendProfileConnection(data);
      reset();
    }
  };
  // console.log(props?.performance?.seeking_employment);

  //Handle change for seeking employment checkbox
  const handleChange = async () => {
    setIsUpdating(true);
    const updatePerformanceData = {
      id: props.performance.id,
      seeking_employment: !props.performance.seeking_employment,
    };

    try {
      await props.updatePerformance(
        props.user.userId.id,
        updatePerformanceData
      );
      setIsUpdating(false);
    } catch (error) {
      setIsUpdating(false);
      console.error("Error updating performance data:", error);
    }
  };

  const [receiverName, setReceiverName] = useState("");

  const [receiverEmail, setReceiverEmail] = useState("");
  const [sendPdfData, setSendPdfData] = useState([]);
  const [senderName, setSenderName] = useState("");
  const [profileStatusId, setProfileStatusId] = useState("");
  const [sendMyProfileId, setSendMyProfileId] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  let date = new Date();
  // Create a date string in the format "YYYY-MM-DD"
  let dateString = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()}`;

  // Initialize state for form-related flags
  const [snedData, setSendData] = useState({
    is_contact: false,
    is_pdf_data: false,
  });
  // Function to handle changes in a select element
  function handleSelectChange(selectedOption) {
    setProfileStatusId(selectedOption.value);
  }
  // console.log(receiverEmail);

  // Function to handle form submission
  const handleSubmit = async (e) => {
    // console.log(receiverEmail);
    e.preventDefault();
    setSendingEmail(true);
    setEmailError(null);
    // console.log("inside function");

    // Check if any required fields are empty, display an error toast, and stop the submission
    // console.log(props.user);
    if (
      !receiverName ||
      // !senderName ||
      !receiverEmail ||
      !props.profile_id ||
      !profileStatusId
    ) {
      toast.error(
        "Some required fields are empty. Please fill them before sending."
      );
      setSendingEmail(false);
      return;
    }
    // setSenderName(props.user.username);

    // Use a toast with promise to show the status of the email sending process
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {

          
          const formdata1 = {
            receiver: receiverName,
           sender_name: props.profile?.first_name || props.user.username,
            sender_email: receiverEmail,
            sender_id:props.profile_id,
            profile_status_id: profileStatusId,
          };
      
          console.log(formdata1);
          // Generate PDF using an API request
          const generatePdf = await axiosInstance.get(
            `/api/performance/html_to_pdf/${props?.profile_id}`
          );
          const response1 = await axiosInstance.put(
            `/api/network/send_my_profile/${sendMyProfileId}/`,
            formdata1
          );
          console.log("pdf generated respons1", response1);
          setSendMyProfileResp(true);
          props.fetchDashboard(props.profile_id);
          // reset();

          setSendMyProfileResp(!sendMyProfileResp);
          resolve(generatePdf.data);
        } catch (error) {
          setEmailError("Error sending email.");
          reject(error);
        } finally {
          setSendingEmail(false);
        }
      }),
      {
        pending: "Email Sending...",
        success: "Successfully sent",
        error: "Try again ,Maybe a refresh can help ",
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      }
    );
  };

  //Fetching user profile data for sending a profile connection
  async function fetchSendMyProfile() {
    try {
      const response = await axiosInstance.get("/api/network/send_my_profile/");
      const sendMyProfile = response.data;
      let fiteredData = [];
      fiteredData = sendMyProfile.filter((item) => {
        return props?.profile_id === item.sender_id;
      });
      if (fiteredData.length > 0) {
        setSendMyProfileId(fiteredData[0].id);
      }
      return sendMyProfile;
    } catch (error) {
      console.error(error);
      // handle the error
      return null;
    }
  }

  useEffect(() => {
    fetchSendMyProfile();
    props.fetchSendMyProfile();
    if (
      Object.keys(props.performance).length === 0 &&
      isData.is_performance === false
    ) {
      setIsData((prevState) => ({ ...prevState, is_performance: true }));
      props.fetchPerformance(props.user.userId.id);
    }

    if (
      Object.keys(props.dashboard).length === 0 &&
      isData.is_dashboard === false
    ) {
      setIsData((prevState) => ({ ...prevState, is_dashboard: true }));
      props.fetchDashboard(props.user.userId.id);
    }

    if (Object.keys(props.dashboard).length > 0) {
      setData([
        // props.dashboard.primary_job_title_years_experience,
        // props.dashboard.primary_job_title_qualification,
        // props.dashboard.primary_job_title_courses,
        // props.dashboard.primary_job_title_competency,
        // props.dashboard.primary_job_title_skills,
        props?.dashboard?.user_experience_score,
        props?.analytics?.qualification_score,
        props?.analytics?.statutory_industry_score,
        props?.analytics?.systems_score,
      ]);
      setPeerData([
        props?.dashboard?.average_peer_experience_score,
        props?.dashboard?.average_peer_qualification_score,
        props?.dashboard?.average_peer_training_score,
        props?.dashboard?.average_peer_systems_score,
      ]);
    }

    if (
      Object.keys(props.analytics).length === 0 &&
      isData.is_analytics === false
    ) {
      setIsData((prevState) => ({ ...prevState, is_analytics: true }));
      props.fetchAnalytics(props.user.id);
    }

    if (Object.keys(props.performance).length > 0) {
      setPdfData([
        [props.performance.pdf_issued],
        [props.performance.pdf_requested],
        [props.performance.profile_pdf_view],
      ]);
    }
    if (Object.keys(props.user).length > 0) {
      axiosInstance
        .get(`/api/network/userProfilePdf/${props.user.userId.id}/`)
        .then(function (response) {
          setSendData((prevState) => ({ ...prevState, is_pdf_data: true }));
          setSendPdfData(response.data);
        });
    }
  }, [props, isData, sendMyProfileResp]);

  const options = [
    { value: "1", label: "Individual" },
    { value: "2", label: "Company" },
    { value: "3", label: "Agency" },
    { value: "4", label: "Organization" },
  ];

  return (
    <div className="content-container" style={{ boxSizing: "border-box" }}>
      <UserLayout>
        <div className="right-section">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="banner">
                <div className="banner-title-overlay">
                  <h5>
                    <span>
                      MY
                      <br />
                      <b>Performance</b>
                      <hr className="bannerhr"
                        style={{
                          height: "5px",
                          background: "white",
                          width: "75%",
                        }}
                      />
                    </span>
                  </h5>
                  <img
                    src="\assets\images\banners\perfomanceIcon.png"
                    className="icon-image "
                  />
                </div>

                <img
                  className="banner-image"
                  src="\assets\images\banners\performanceBanner.png"
                  alt="Not Found"
                />
              </div>
            </div>
          </div>
          <div className="timeline-block ">
            <div className="row" id="target-status">
              <div className="timeline-icon completed">
                <span className="ni nicon-job-status"></span>
              </div>
              <div className="col-12">
                <h5 className="timeline-title">Job Status</h5>
                <label className="custom-radio">
                  Seeking employment &nbsp;&nbsp;
                  <label
                    className="switch"
                    style={{
                      backgroundColor: props.performance.seeking_employment
                        ? "#2bb4b0"
                        : "",
                    }}
                  >
                    <input
                      type="checkbox"
                      onClick={handleChange}
                      defaultChecked={props.performance.seeking_employment}
                      disabled={isUpdating}
                    />
                    <span className="slider round"></span>
                  </label>
                  {/* Loading Spinner (Displayed when updating) */}
                  {isUpdating && (
                    <span>
                      {" "}
                      <ClipLoader
                        color={"grey"}
                        loading={isUpdating}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </span>
                  )}
                </label>
              </div>
            </div>
            <div className="row" id="target-search">
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <div
                  className="row network-reference-row"
                  id="target-reference"
                >
                  <div className="col-12">
                    <div className="row">
                      <div className="col-lg-12   col-12">
                        <label className="timeline-label"></label>
                        <div className="reference-box">
                          <ul className="contact-list">
                            <li>
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="\assets\images\profileStatus icons\agencyDashIcon.png"
                                    alt=""
                                    style={{ height: "46px", width: "auto" }}
                                  />
                                  <span>Agencies</span>
                                </div>
                                {/* Display the count of Agencies */}
                                <span className="count-box">
                                  {props?.dashboard?.total_agency_count}
                                </span>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="\assets\images\profileStatus icons\companyDashIcon.png"
                                    alt=""
                                    style={{ height: "48px", width: "auto" }}
                                  />
                                  <span>Companies</span>
                                </div>
                                {/* Display the count of Companies */}
                                <span className="count-box">
                                  {props?.dashboard?.total_company_count}
                                </span>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="\assets\images\profileStatus icons\organisationDashIcon.png"
                                    alt=""
                                    style={{ height: "48px", width: "auto" }}
                                  />

                                  <span>organisation</span>
                                </div>
                                {/* Display the count of Organizations */}
                                <span className="count-box">
                                  {props?.dashboard?.total_organization_count}
                                </span>
                              </div>
                            </li>
                            <li>
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="\assets\images\profileStatus icons\IndividualDash.png"
                                    alt=""
                                    style={{ height: "48px", width: "auto" }}
                                  />
                                  <span>Individuals</span>
                                </div>
                                {/* <span className="count-box count-fill"> */}
                                {/* Display the count of Individuals */}
                                <span className="count-box ">
                                  {props?.dashboard?.total_individual_count}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Profile Send Form Section */}
              <div className="col-lg-12 pending-column ms-5">
                <h6 className="timeline-subtitle">
                  <strong>Send</strong> MY <strong>Profile</strong>
                </h6>
                {/* Form for Sending Profile */}
                <form onSubmit={handleSubmit}>
                  <div className="clone-card cloneTarget">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          name="receiver_name"
                          className="form-control"
                          placeholder="Recipient Name"
                          {...register("receiver_name", {
                            required: "Receiver Name is Required",
                          })}
                          onChange={(e) => {
                            setReceiverName(e.target.value);
                          }}
                        />
                        {/* Display Validation Error if any */}
                        {errors.receiver_name ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.email?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* Receiver Email Input */}
                      <div className="col-md-6 col-12 mb-3">
                        <input
                          type="email"
                          name="receiver_email"
                          className="form-control"
                          placeholder="Recipient Email"
                          {...register("receiver_email", {
                            required: "Email is Required",
                            pattern: {
                              value:
                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                              message: "Email is not Valid",
                            },
                          })}
                          onChange={(e) => {
                            setReceiverEmail(e.target.value);
                          }}
                        />
                        {/* Display Validation Error if any */}
                        {errors.receiver_email ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.email?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Sender Information Input Section */}
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div className="col-md-6 col-12 ">
                      <Select
                        id="primary_category"
                        name="primary_category"
                        placeholder="Choose.."
                        isClearable={true}
                        options={options}
                        onChange={handleSelectChange}
                      />
                    </div>

                    <div className="col-md-6 col-12 mb-3">
                      {/* <input
                      type="text"
                      name="company_name"
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => {
                        setSenderName(e.target.value);
                      }}
                    /> */}
                      {props.analytics &&
                      props.analytics.profile_fill === 100 ? (
                        <>
                          {/* Display Send Button and Toast Notification */}
                          <button
                            className="btn btn-blue mt-3"
                            // style={{ float: "right" }}
                          >
                            Send
                          </button>
                          <ToastContainer
                            position="bottom-left"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="dark"
                          />
                        </>
                      ) : (
                        <div>
                          Please complete your profile to 100% to generate CV
                        </div>
                      )}
                    </div>
                  </div>
                  <br />
                  {/* Check if Profile is 100% Complete */}
                </form>
              </div>
            </div>

            <div className="row " id="target-performance">
              <div className="timeline-icon completed">
                <span className="ni nicon-performance"></span>
              </div>
              <div className="col-12">
                <h5 className="timeline-title">
                  MY <strong>Score v’s </strong> MY
                  <strong> Network PEER Group</strong>{" "}
                </h5>
                {/* Display Primary Job from Dashboard Data */}
                <label className="pt-3 pb-3">
                  Primary Job : {props?.dashboard?.primary_job}
                </label>
                {/* Performance Bar Component */}
                <div id="peerGroupperformance" className="border border-info">
                  {/* Render the PerformanceBar Component with Data */}
                  <PerformanceBar data={data} peerData={peerData} />
                </div>
              </div>
            </div>

            <div className="row " id="target-reference">
              <div className="timeline-icon completed">
                <span className="ni nicon-network"></span>
              </div>
              <div
                style={{
                  width: "100%",
                }}
              >
                <div className="row network-reference-row" id="">
                  <div className="col-12">
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12 col-12"
                        // style={{ paddingRight: "30px", paddingLeft: "30px" }}
                        style={ isMobile ? {} : { paddingRight: "30px", paddingLeft: "30px" }}
                      >
                        <label className="timeline-label d-flex justify-content-between"></label>
                        <div className="reference-box">
                          <h5 className="timeline-title">
                            MY <strong>Network Status</strong>
                          </h5>
                          {/* List of network status items */}
                          <ul
                            className="row text-center m-3"
                            style={{ justifyContent: "space-between" }}
                          >
                            {/* Function to display total users in the network */}
                            <li style={{ paddingLeft: "0px" }}>
                              <div className=" d-flex row">
                                <div className="col ">
                                  <h1
                                    style={{
                                      borderRadius: "4px",
                                      padding: "10px 25px", // Add desired padding for x and y
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                      border: "2px solid #007bff",
                                      margin: 0, // Remove default margin to avoid unwanted spacing
                                    }}
                                  >
                                    {props?.dashboard?.total_users_network}
                                  </h1>
                                </div>
                                <p
                                  style={{
                                    margin: "",
                                    marginRight: "",
                                    textAlign: "start",
                                    // fontSize:'15px'
                                  }}
                                >
                                  MY Network <br />
                                  <b style={{ color: "#283270" }}>Total</b>
                                </p>
                              </div>
                            </li>
                            {/* Function to display the number of users in primary job */}
                            <li style={{ paddingLeft: "0px" }}>
                              <div className=" d-flex  row">
                                <div className="col ">
                                  <h1
                                    style={{
                                      borderRadius: "4px",
                                      padding: "10px 25px", // Add desired padding for x and y
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                      border: "2px solid #dc3545",
                                      margin: 0, // Remove default margin to avoid unwanted spacing
                                    }}
                                  >
                                    {props?.dashboard?.no_of_users_primary}
                                  </h1>
                                </div>
                                <p
                                  style={{
                                    margin: "",
                                    marginRight: "",
                                    textAlign: "start",
                                  }}
                                >
                                  Primary <br />
                                  <b style={{ color: "#283270" }}>Job </b>
                                </p>
                                &nbsp;
                              </div>
                            </li>
                            {/* Function to display the number of users in secondary job */}
                            <li style={{ paddingLeft: "0px" }}>
                              <div className=" d-flex  row">
                                <div className="col ">
                                  <h1
                                    style={{
                                      borderRadius: "4px",
                                      padding: "10px 25px", // Add desired padding for x and y
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                      border: "2px solid #ffc107",
                                      margin: 0, // Remove default margin to avoid unwanted spacing
                                    }}
                                  >
                                    {props?.dashboard?.no_of_users_secondary}
                                  </h1>
                                </div>
                                <p
                                  style={{
                                    margin: "",
                                    marginRight: "",
                                    textAlign: "start",
                                  }}
                                >
                                  Secondary <br />
                                  <b style={{ color: "#283270" }}>Job </b>
                                </p>
                                &nbsp;
                              </div>
                            </li>
                            {/* Function to display the number of users seeking employment */}
                            <li style={{ paddingLeft: "0px" }}>
                              <div className=" d-flex  row">
                                <div className="col ">
                                  <h1
                                    style={{
                                      borderRadius: "4px",
                                      padding: "10px 25px", // Add desired padding for x and y
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                      border: "2px solid #17a2b8",
                                      margin: 0, // Remove default margin to avoid unwanted spacing
                                    }}
                                  >
                                    {
                                      props?.dashboard
                                        ?.no_of_users_seeking_employment
                                    }
                                  </h1>
                                </div>
                                <p
                                  style={{
                                    margin: "",
                                    marginRight: "",
                                    textAlign: "start",
                                    // fontSize:'15px'
                                  }}
                                >
                                  Seeking <br />
                                  <b style={{ color: "#283270" }}>Employment</b>
                                </p>
                                &nbsp;
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row cm-35">
            <div className="col-12">
              <ul className="quick-links ">
                {/* Profile Link */}
                <li>
                  <Link to="/user/profile">
                    <span className="icon-wrap">
                      <img
                        src="\assets\images\quick-links\profile.svg"
                        alt=""
                      />
                    </span>
                    <label className="blue">
                      MY <br />
                      <strong>Profile</strong>
                    </label>
                  </Link>
                </li>
                {/* Profile Analytics Link */}
                <li>
                  <Link to="/user/profile-analytics">
                    <span className="icon-wrap">
                      <img
                        src="/assets/images/quick-links/analytics.svg"
                        alt=""
                      />
                    </span>
                    <label className="red">
                      <strong>goneet</strong>
                      <br />
                      <span
                        style={{
                          backgroundColor: "#283270",
                          color: "white",
                          padding: "2px",
                          borderRadius: "5px",
                        }}
                      >
                        PRO
                      </span>
                    </label>
                  </Link>
                </li>
                {/* Network Link */}
                <li>
                  <Link to="/user/network">
                    <span className="icon-wrap">
                      <img
                        src="/assets/images/quick-links/network.svg"
                        alt=""
                      />
                    </span>
                    <label className="orange">
                      MY
                      <br /> <strong>Network</strong> <br></br>
                    </label>
                  </Link>
                </li>
                {/* Active Performance Link */}
                <li className="active">
                  <div className="here-menu">
                    <label>YOUR HERE</label>
                    <img src="/assets/images/downround-icon.png" alt="" />
                  </div>
                  <Link to="/user/performance">
                    <span className="icon-wrap">
                      <img
                        src="/assets/images/quick-links/performance-active.svg"
                        alt=""
                      />
                    </span>
                    <label className="green">
                      MY
                      <br />
                      <strong>Performance</strong>
                      <br></br>
                    </label>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </UserLayout>
    </div>
  );
};
const mapStateToProps = (state) => {
    const user = state.user.user;
    const dashboard = state.dashboard.dashboard;
    const is_dashboard = state.dashboard.is_dashboard;
    const analytics = state.analytics.analytics;
    const is_analytics = state.dashboard.is_dashboard;
    const performance = state.performance.performance;
    const is_performance = state.performance.is_performance;
    const profile_id = state.user.profile.id;
    const profile = state.user.profile; // Add this line to access profile data
    
    return {
        user: user,
        dashboard: dashboard,
        is_dashboard: is_dashboard,
        analytics: analytics,
        is_analytics: is_analytics,
        performance: performance,
        is_performance: is_performance,
        profile_id: profile_id,
        profile: profile, // Add this line
    };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchDashboard: (userId) => dispatch(fetchDashboardAction(userId)),
    fetchAnalytics: (userId) => dispatch(fetchAnalyticsAction(userId)),
    fetchPerformance: (userId) => dispatch(fetchPerformanceAction(userId)),
    updatePerformance: (id, data) =>
      dispatch(updatePerformanceAction(id, data)),
    sendProfileConnection: (data) =>
      dispatch(sendProfileConnectionAction(data)),
    fetchSendMyProfile: () => dispatch(fetchSendMyProfileAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Performance);












